import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Home',
  to: '/'
}, {
  label: 'Profile',
  to: '/#about'
}, {
  label: 'Experience',
  to: '/#experience'
}, {
  label: 'Board',
  to: '/#board'
}, {
  label: 'Insights',
  to: '/insights'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? 'bg-navy/90 backdrop-blur-xl shadow-lux' : 'bg-transparent'}`} data-id="element-276" data-mp="1q0dzfvchjefc">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-277" data-mp="9o7vg1myzine">
        <Link to="/" className="group flex flex-col leading-none" data-id="element-278" data-mp="elpu8z79whho">
          <span className="font-display text-lg font-normal tracking-wide text-white" data-id="element-279" data-mp="jnox87z3pce3">
            Jessica L. Cumbee
          </span>
          <span className="eyebrow mt-1 text-[0.6rem] text-gold transition-colors group-hover:text-gold-light" data-id="element-280" data-mp="okysi4968i9u">
            Chief Legal Officer
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-9 lg:flex" data-id="element-281" data-mp="3s38ox2k4imr1">
          {links.map(link => <NavLink key={link.label} to={link.to} className="group relative text-[0.8rem] font-medium tracking-wide text-slate-200 transition-colors hover:text-white" data-id="element-282" data-mp="uur83jggum0">
              {link.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" data-id="element-283" data-mp="39bfr8uu40dcz" />
            </NavLink>)}
          <Link to="/contact" className="btn-lux border border-gold/60 px-6 py-2.5 text-[0.7rem] font-medium uppercase tracking-micro text-gold transition-colors duration-300 hover:text-navy" data-id="element-284" data-mp="3196t51blxmih">
            Connect
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} className="text-white lg:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-285" data-mp="362i33bbpujem">
          {open ? <XIcon className="h-6 w-6" data-id="element-286" data-mp="2salehh99armz" /> : <MenuIcon className="h-6 w-6" data-id="element-287" data-mp="2sav59724l2tq" />}
        </button>
      </div>

      <AnimatePresence data-id="element-288" data-mp="2nbi9fwta0lf0">
        {open ? <motion.nav aria-label="Mobile" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="overflow-hidden border-t border-white/10 bg-navy/95 backdrop-blur-xl lg:hidden" data-id="element-289" data-mp="2napb9k8dv48h">
            <ul className="space-y-1 px-6 py-6" data-id="element-290" data-mp="f458mwd5d2it">
              {[...links, {
            label: 'Connect',
            to: '/contact'
          }].map(link => <li key={link.label} data-id="element-291" data-mp="15x7sdczph2d">
                  <Link to={link.to} className="block border-b border-white/5 py-3 text-sm tracking-wide text-slate-200" data-id="element-292" data-mp="55fqr3l93i2k">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </motion.nav> : null}
      </AnimatePresence>
    </header>;
}